module.exports = __webpack_public_path__ + "static/media/enac-27001.d922ea05.svg";